module.exports = __webpack_public_path__ + "media/images/icon__calendar@2x-07f59825f0e6bda068c0a333d3a49ae0.png";